export const Log = window.console;
